import React from "react";
import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import naacLogo from "../assets/img/rec/naac.webp";
import cgGovtLogo from "../assets/img/rec/chhattisgarh-government.webp";
import ugcLogo from "../assets/img/rec/ugc.png";
import aicteLogo from "../assets/img/rec/aicte.webp";
import aacsbLogo from "../assets/img/rec/aacsb.png";
import cgpurcLogo from "../assets/img/rec/cgpurc.webp";
import bciLogo from "../assets/img/rec/bci.webp";
import pciLogo from "../assets/img/rec/pci.webp";
import aiuLogo from "../assets/img/rec/aiu.webp";
import nsdcLogo from "../assets/img/rec/nsdc.webp";
import iauLogo from "../assets/img/rec/iau.webp";
import assochamLogo from "../assets/img/rec/assocham.webp";
import ciiLogo from "../assets/img/rec/cii.webp";
import phdLogo from "../assets/img/rec/phd-chamber.webp";
import iaccLogo from "../assets/img/rec/indo-american-chamber.webp";
import euLogo from "../assets/img/rec/eu-chambers.webp";
import cippLogo from "../assets/img/rec/cipp.webp";
import sdsnLogo from "../assets/img/rec/sdsn.webp";
import ungcLogo from "../assets/img/rec/un-global-compact-network-india.webp";
import unaiLogo from "../assets/img/rec/united-nations-academic-impact.webp";
import doraLogo from "../assets/img/rec/dora.webp";
import isteLogo from "../assets/img/rec/iste.webp";
import istdLogo from "../assets/img/rec/istd.webp";
import bmaLogo from "../assets/img/rec/bma.webp";
import aimsLogo from "../assets/img/rec/aims-international.webp";
import cegrLogo from "../assets/img/rec/cegr.webp";
import aurobindoLogo from "../assets/img/rec/sri-aurobindo-society.webp";
import egacLogo from "../assets/img/rec/egac.webp";
import gaaLogo from "../assets/img/rec/globally_img.webp"

const approvals = [
  {
    name: "National Assessment and Accreditation Council (NAAC)",
    image: naacLogo,
  },
  {
    name: "Accredited by Chhattisgarh State Government University Establishment Act",
    image: cgGovtLogo,
  },
  {
    name: "Approved by the University Grants Commission (UGC)",
    image: ugcLogo,
  },
  {
    name: "Recognized by AICTE (All India Council for Technical Education)",
    image: aicteLogo,
  },
  {
    name: "Association to Advance Collegiate Schools of Business",
    image: aacsbLogo,
  },
  {
    name: "Chhattisgarh Private Universities Regulatory Commission (CG-PURC)",
    image: cgpurcLogo,
  },
  { name: "Bar Council of India (BCI)", image: bciLogo },
  { name: "Pharmacy Council of India", image: pciLogo },
  { name: "Association of Indian Universities (AIU)", image: aiuLogo },
  { name: "National Skill Development Corporation", image: nsdcLogo },
  {
    name: "Member – International Association of Universities (IAU)",
    image: iauLogo,
  },
];

const corporate = [
  {
    name: "ASSOCHAM",
    text: "Recognized by ASSOCHAM for academic excellence and institutional quality.",
    image: assochamLogo,
  },
  {
    name: "CII (Confederation of Indian Industry)",
    text: "Member of CII, supporting industry-driven academic standards in education.",
    image: ciiLogo,
  },
  {
    name: "PHD Chamber",
    text: "Affiliated with the PHD Chamber, promoting technical and coordinated education development",
    image: phdLogo,
  },
];

const memberships = [
  { name: "Indo-American Chamber of Commerce", image: iaccLogo },
  { name: "The Council of EU Chambers of Commerce in India", image: euLogo },
  { name: "The Chartered Institute of Payroll Professionals", image: cippLogo },
  { name: "Sustainable Development Solutions Network", image: sdsnLogo },
  { name: "UN Global Compact Network India", image: ungcLogo },
  { name: "United Nations Academic Impact", image: unaiLogo },
  { name: "Member of DORA", image: doraLogo },
];

const national = [
  { name: "Indian Society for Technical Education (ISTE)", image: isteLogo },
  { name: "Indian Society for Training & Development (ISTD)", image: istdLogo },
  { name: "Bombay Management Association (BMA)", image: bmaLogo },
  { name: "AIMS International", image: aimsLogo },
  { name: "Center for Education Growth & Research", image: cegrLogo },
  { name: "SRI Aurobindo Society", image: aurobindoLogo },
];

function LogoCard({ item, index }) {
  return (
    <article className="group border-b border-r border-[#071A2F]/10 bg-white p-6 transition hover:z-10 hover:shadow-[0_20px_60px_rgba(7,26,47,.09)]">
      <div className="flex h-[150px] items-center justify-center rounded-[22px] bg-[#F7F2E8] p-6">
        <img
          src={item.image}
          alt={item.name}
          className="max-h-[115px] max-w-[190px] object-contain transition group-hover:scale-[1.04]"
        />
      </div>
      <div className="mt-6 flex items-start gap-4">
        <span className="mt-1 text-[10px] font-bold tracking-[0.14em] text-[#D5AD57]">
          {String(index + 1).padStart(2, "0")}
        </span>
        <h3 className="font-['Libre_Caslon_Display',Georgia,serif] text-[20px] font-normal leading-[1.3] text-[#071A2F]">
          {item.name}
        </h3>
      </div>
    </article>
  );
}

export default function AccreditationsAndRecognitions() {
  return (
    <>
      <MetaInfo param="" id="about" />
      <Header school="common" />

      <main className="overflow-hidden bg-white text-[#132337]">
        <section className="relative isolate min-h-[780px] overflow-hidden bg-[#071A2F] pt-[100px] text-white">
          <div className="absolute inset-0 -z-30 bg-[radial-gradient(circle_at_82%_18%,rgba(213,173,87,.18),transparent_27%),radial-gradient(circle_at_15%_82%,rgba(139,30,63,.25),transparent_31%)]" />
          <div className="absolute inset-0 -z-20 opacity-[.055] [background-image:linear-gradient(rgba(255,255,255,.35)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.35)_1px,transparent_1px)] [background-size:72px_72px]" />
          <div className="absolute -right-[190px] top-[70px] -z-10 h-[650px] w-[650px] rounded-full border border-white/10" />

          <div className="mx-auto grid min-h-[575px] w-[min(1380px,calc(100%-48px))] items-center gap-14 pb-20 max-sm:w-[calc(100%-28px)] lg:grid-cols-[1.05fr_.95fr]">
            <div>
              <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                <span className="h-px w-12 bg-current" />
                Accreditations & Recognitions
              </div>
              <h1 className="mt-7 max-w-[850px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,6.8vw,96px)] font-normal leading-[.94] tracking-[-.05em]">
                Recognized.
                <span className="block text-[#D5AD57]">
                  Connected. Trusted.
                </span>
              </h1>
              <p className="mt-8 max-w-[680px] text-[17px] leading-8 text-white/65">
                Explore the approvals, memberships, associations, recognitions
                and quality frameworks presented by ISBM University.
              </p>
              <a
                href="#approvals"
                className="mt-10 inline-flex min-h-[54px] items-center rounded-full bg-[#D5AD57] px-7 text-xs font-bold uppercase tracking-[.12em] text-[#071A2F]"
              >
                Explore Recognitions
              </a>
            </div>

            <div className="relative hidden min-h-[490px] lg:block">
              <div className="absolute right-0 top-0 grid h-[390px] w-[390px] grid-cols-2 gap-px overflow-hidden rounded-[36px] border border-white/10 bg-white/10 p-px shadow-[0_35px_100px_rgba(0,0,0,.28)]">
                {[naacLogo, ugcLogo, aicteLogo, aiuLogo].map((logo, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-center bg-white p-7"
                  >
                    <img
                      src={logo}
                      alt=""
                      className="max-h-[115px] max-w-[125px] object-contain"
                    />
                  </div>
                ))}
              </div>
              <div className="absolute bottom-0 left-0 w-[265px] rounded-[28px] border border-white/10 bg-[#8B1E3F] p-7 shadow-[0_20px_60px_rgba(0,0,0,.25)]">
                <span className="text-[10px] font-bold uppercase tracking-[.16em] text-[#D5AD57]">
                  Institutional Network
                </span>
                <strong className="mt-5 block font-['Libre_Caslon_Display',Georgia,serif] text-[50px] font-normal leading-none">
                  30+
                </strong>
                <p className="mt-3 text-sm leading-6 text-white/60">
                  Approvals, memberships, associations and recognitions
                  represented across the University ecosystem.
                </p>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 bg-white/[.035]">
            <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] sm:grid-cols-4">
              {[
                "Approvals",
                "Corporate Memberships",
                "Global Memberships",
                "Quality Assurance",
              ].map((item, index) => (
                <div
                  key={item}
                  className="py-6 sm:border-r sm:border-white/10 sm:px-7"
                >
                  <span className="text-[10px] font-bold text-[#D5AD57]">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <p className="mt-2 text-sm font-semibold text-white/80">
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-white py-20 sm:py-24 lg:py-28">
          <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-12 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.72fr_1.28fr] lg:gap-20">
            <div>
              <Eyebrow>Institutional Standing</Eyebrow>
              <Title
                before="Accredited for Success,"
                highlight="Connected for Growth"
                after=""
                position="middle"
                theme="burgundy"
              />
            </div>
            <div className="lg:pt-8">
              <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(28px,3vw,43px)] font-normal leading-[1.32] text-[#071A2F]">
                Our accreditation ensures that you meet and exceed industry
                standards, while our robust membership network fosters
                invaluable connections and opportunities for growth.
              </p>
            </div>
          </div>
        </section>

        <section
          id="approvals"
          className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28"
        >
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <Eyebrow>Approvals</Eyebrow>
            <Title
              before="Recognised Across"
              highlight="Key Academic Bodies"
              after=""
              position="middle"
              theme="burgundy"
            />
            <div className="mt-12 grid overflow-hidden rounded-[30px] border-l border-t border-[#071A2F]/10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {approvals.map((item, index) => (
                <LogoCard key={item.name} item={item} index={index} />
              ))}
            </div>
          </div>
        </section>

        <section className="bg-white py-20 sm:py-24 lg:py-28">
          <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-6 max-sm:w-[calc(100%-28px)] lg:grid-cols-2">
            <article className="relative overflow-hidden rounded-[34px] bg-[#071A2F] p-8 text-white sm:p-12">
              <span className="text-xs font-bold uppercase tracking-[.16em] text-[#D5AD57]">
                Off Campus Center
              </span>
              <div className="mt-12 flex h-[150px] w-[150px] items-center justify-center rounded-[20px] bg-white p-5">
                <img
                  src={cgGovtLogo}
                  alt="Government of Chhattisgarh"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <h2 className="mt-8 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(32px,3vw,46px)] font-normal leading-[1.1]">
                Government of Chhattisgarh Recognition
              </h2>
              <p className="mt-6 text-sm leading-7 text-white/65">
                ISBM University is recognized by the Government of Chhattisgarh,
                affirming its legal establishment and operational legitimacy
                under Chhattisgarh Private Universities Act. This recognition
                ensures adherence to state educational standards and enables
                students to pursue education with full official support.
              </p>
            </article>
            <article className="rounded-[34px] bg-[#EEF4F8] p-8 sm:p-12">
              <span className="text-xs font-bold uppercase tracking-[.16em] text-[#8B1E3F]">
                Degree Recognition
              </span>
              <div className="mt-12 flex h-[150px] w-[150px] items-center justify-center rounded-[20px] bg-white p-5">
                <img
                  src={ugcLogo}
                  alt="University Grants Commission"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <h2 className="mt-8 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(32px,3vw,46px)] font-normal leading-[1.1] text-[#071A2F]">
                ISBM University follows UGC norms.
              </h2>
              <p className="mt-6 text-sm leading-7 text-[#132337]/60">
                As per university equivalence guidelines, degrees from
                UGC-recognized private universities are considered for higher
                education eligibility, subject to compliance.
              </p>
            </article>
          </div>
        </section>

        <section className="bg-[#071A2F] py-20 text-white sm:py-24 lg:py-28">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <Eyebrow dark>Corporate Memberships & Recognitions</Eyebrow>
            <Title
              before="Where Academia Meets"
              highlight="Industry Networks"
              after=""
              position="middle"
              theme="gold"
              dark
            />
            <div className="mt-14 grid gap-5 lg:grid-cols-3">
              {corporate.map((item, index) => (
                <article
                  key={item.name}
                  className="rounded-[30px] border border-white/10 bg-white/[.055] p-8"
                >
                  <div className="flex h-[120px] items-center justify-center rounded-[20px] bg-white p-6">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="max-h-[80px] max-w-[180px] object-contain"
                    />
                  </div>
                  <span className="mt-7 block text-[10px] font-bold text-[#D5AD57]">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-2 font-['Libre_Caslon_Display',Georgia,serif] text-[28px] font-normal">
                    {item.name}
                  </h3>
                  <p className="mt-4 text-sm leading-7 text-white/55">
                    {item.text}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-[#FDF7FC] py-20 sm:py-24 lg:py-28">
          <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-12 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.68fr_1.32fr] lg:gap-20">
            <div>
              <Eyebrow>Memberships</Eyebrow>
              <Title
                before="Connected to"
                highlight="Global Networks"
                after=""
                position="middle"
                theme="burgundy"
              />
            </div>
            <div className="grid gap-4 sm:grid-cols-2">
              {memberships.map((item, index) => (
                <article
                  key={item.name}
                  className="flex min-h-[145px] items-center gap-5 rounded-[24px] border border-[#071A2F]/10 bg-white p-5"
                >
                  <div className="flex h-[88px] w-[112px] shrink-0 items-center justify-center rounded-[17px] bg-[#F7F2E8] p-4">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="max-h-full max-w-full object-contain"
                    />
                  </div>
                  <div>
                    <span className="text-[10px] font-bold text-[#D5AD57]">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <h3 className="mt-2 font-['Libre_Caslon_Display',Georgia,serif] text-[20px] font-normal leading-[1.25] text-[#071A2F]">
                      {item.name}
                    </h3>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-white py-20 sm:py-24 lg:py-28">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <Eyebrow>National Associations & Memberships</Eyebrow>
            <Title
              before="Professional Connections That"
              highlight="Extend Our Ecosystem"
              after=""
              position="middle"
              theme="burgundy"
            />
            <div className="mt-12 grid gap-px overflow-hidden rounded-[30px] bg-[#071A2F]/10 sm:grid-cols-2 lg:grid-cols-3">
              {national.map((item, index) => (
                <article key={item.name} className="bg-[#EEF4F8] p-8">
                  <div className="flex h-[110px] w-[150px] items-center justify-center rounded-[18px] bg-white p-5">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="max-h-full max-w-full object-contain"
                    />
                  </div>
                  <span className="mt-7 block text-[10px] font-bold text-[#D5AD57]">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-2 font-['Libre_Caslon_Display',Georgia,serif] text-[24px] font-normal leading-[1.2] text-[#071A2F]">
                    {item.name}
                  </h3>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="relative overflow-hidden bg-[#8B1E3F] py-20 text-white sm:py-24 lg:py-28">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <Eyebrow dark>Quality Assurance & Compliances</Eyebrow>
            <Title
              before="Quality Benchmarks With"
              highlight="Global Perspective"
              after=""
              position="middle"
              theme="gold"
              dark
            />
            <div className="mt-14 grid gap-6 lg:grid-cols-2">
              <article className="rounded-[32px] border border-white/10 bg-white/[.07] p-8 sm:p-10">
                <div className="flex h-[125px] items-center justify-center rounded-[18px] bg-white p-5">
                  <img
                    src={egacLogo}
                    alt="Global Recognitions and Accreditations"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <h3 className="mt-7 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(34px,3.5vw,50px)] font-normal leading-[1.08]">
                  Global Recognitions and Accreditations
                </h3>
                <p className="mt-5 text-[15px] leading-8 text-white/65">
                  ISBM University is proud to be recognized by esteemed
                  international bodies, including the Egyptian Accreditation
                  Council (EGAC). These rec highlight global quality standards,
                  emphasizing excellence, institutional quality, and
                  international credibility. They reflect our commitment to
                  delivering a global standard of education.
                </p>
              </article>
              <article className="rounded-[32px] border border-[#D5AD57]/30 bg-[#071A2F] p-8 sm:p-10">
                <div className="flex h-[125px] items-center justify-center rounded-[18px] bg-white p-5">
                  <img
                    src={gaaLogo}
                    alt="Global Recognitions and Accreditations"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <h3 className="mt-7 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(34px,3.5vw,50px)] font-normal leading-[1.08]">
                  Globally Assured Accreditations
                </h3>
                <p className="mt-6 text-[15px] leading-8 text-white/60">
                  ISBM University upholds global recognitions through
                  prestigious international forums like EGAC. These rec affirm
                  adherence to internationally benchmarked academic and
                  institutional quality standards. We're committed to offering
                  education that is trusted, respected, and aligned with global
                  best practices.
                </p>
              </article>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
